import { useMemo } from 'react';
import useFetchFilteredOverviews from './useFetchFilteredOverviews';

type Params = {
    url: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    pollingInterval?: number;
};

export default function useGetOverviewsWithLastReport({ url, startDate, endDate, pollingInterval }: Params) {
    const {
        data: analysisOverviews,
        isLoading: isLoadingAnalysisOverviews,
        isFetching: isFetchingAnalysisOverviews,
    } = useFetchFilteredOverviews({
        url,
        startDate,
        endDate,
        pollingInterval,
    });

    const lastSavedReportOverview = useMemo(
        () => (!!analysisOverviews && analysisOverviews.length > 0 ? analysisOverviews[analysisOverviews.length - 1] : undefined),
        [analysisOverviews]
    );

    return {
        analysisOverviews,
        lastSavedReportOverview,
        isLoadingAnalysisOverviews,
        isFetchingAnalysisOverviews,
    };
}
